import React from 'react';
import { Link } from 'react-router-dom';
import styles from './Navigation.module.scss';

interface MobileNavProps {
  isOpen: boolean;
  onToggle: () => void;
  onClose: () => void;
}

export const MobileNav: React.FC<MobileNavProps> = ({ isOpen, onToggle, onClose }) => {
  return (
    <div className={styles.mobileNavContainer}>
      <button 
        className={`${styles.hamburgerBtn} ${isOpen ? styles.open : ''}`}
        onClick={onToggle}
        aria-label="Toggle Menu"
      >
        <span />
        <span />
        <span />
      </button>

      <div className={`${styles.mobileMenu} ${isOpen ? styles.open : ''}`}>
        <div className={styles.mobileLinks}>
            <Link to="/science-of-time" onClick={onClose}>Science</Link>
            <Link to="/blog" onClick={onClose}>Blog</Link>
            <Link to="/about" onClick={onClose}>About Us</Link>
            <div className={styles.mobileAuth}>
                <Link to="/login" className={styles.loginLink} onClick={onClose}>
                    Log In
                </Link>
                <Link to="/register" className={styles.primaryButton} onClick={onClose}>
                    Sign Up Free
                </Link>
            </div>
        </div>
      </div>
      
      {isOpen && <div className={styles.backdrop} onClick={onClose} />}
    </div>
  );
};
